import { Box, Typography, Button, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import { useUser } from "./UserContext";


export default function HomePage() {
  const { user } = useUser();
  return (
    <Box
      component={Paper}
      elevation={3}
      sx={{ p: 3, textAlign: "center" }}
    >
      <Typography variant="h3" component="h1" gutterBottom>
        Next Moca Enterprise Agent Planner
      </Typography>
      <Box sx={{ mt: 4 }}>
        {user ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <Typography variant="h4" component="div" color="primary" sx={{ fontWeight: 700, mb: 1, textShadow: "0 2px 8px rgba(0,0,0,0.12)" }}>
              Welcome, {user.username}!
            </Typography>
            <Box sx={{ width: 60, height: 4, bgcolor: "primary.main", borderRadius: 2, mb: 2 }} />
          </Box>
        ) : (
          <Typography variant="h6">
            Please log in to access the agent management features.
          </Typography>
        )}
        <Box sx={{ my: 4 }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Generate reusable AI agents and tools intuitively and instantly!<br/>
            Make them smarter with your own data and knowledge base!<br/>
            Build, deploy and run your agents with ease anywhere!<br/>
            Monitor governance, risk and compliance with built-in audit trails!
          </Typography>
        </Box>
        <Box sx={{ mt: 4 }}>
          <Typography variant="body" color="text.secondary" sx={{ mt: 4 }}>
              Get started by creating your first agent or exploring existing ones!
          </Typography>
        </Box>
        <Box sx={{ mt: 4 }}>
          <Button
            component={Link}
            to="/agents"
            variant="contained"
            color="primary"
            sx={{ mr: 2 }}
          >
            View Agents
          </Button>
          <Button
            component={Link}
            to="/agent/conversational"
            variant="outlined"
            color="primary"
          >
            Create Agent
          </Button>
        </Box>
      </Box>
    </Box>
  );
}